<div
  class="crowdctrl-form-checkbox-group-wrap"
  role="group"
  [attr.aria-label]="ariaLabel"
  [attr.aria-disabled]="disabled ? 'true' : null"
>
  @if (items.length === 0) {
    <div class="crowdctrl-form-checkbox-group__empty" role="status">{{ emptyMessage }}</div>
  } @else {
    @for (item of items; track item.id) {
      <div
        class="crowdctrl-form-checkbox-group__row"
        [class.crowdctrl-form-checkbox-group__row--disabled]="disabled"
        (click)="onRowClick($event, item)"
      >
        <ion-checkbox
          [checked]="isSelected(item.id)"
          [disabled]="disabled"
          (ionChange)="onCheckboxIonChange(item, $event)"
          (click)="$event.stopPropagation()"
        ></ion-checkbox>
        <div class="crowdctrl-form-checkbox-group__text">
          <span class="crowdctrl-form-checkbox-group__title">{{ item.title }}</span>
          @if (item.description) {
            <span class="crowdctrl-form-checkbox-group__desc">{{ item.description }}</span>
          }
        </div>
      </div>
    }
  }
</div>
